import React from "react";

const NotFound = () => {
    return (
        <div style={{ padding: "40px", textAlign: "center" }}>
            <h2>404 - Pagina no encontrada</h2>
            <p>La ruta solicitada no existe o fue movida.</p>
        </div>
    );
};

export default NotFound;
